import React from 'react';
import PropTypes from 'prop-types';

import DataTableToolbar from '../../_Shared/DataTables/DataToolbar';
import DataTable from '../../_Shared/DataTables/DataTable';
import AppContent from '../../_Shared/Layout/AppContent';

import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import LinearProgress from '@material-ui/core/LinearProgress';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import TextField from '@material-ui/core/TextField';

import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';

import CreateModal from '../../_Shared/CreateModal';

const _ = require('lodash');

class ExternalFieldList extends React.Component {

    constructor(props) {
        super(props); 
        
        this.state = {
            name: '',
            showModal: false,
            anchorEl: null
        }
    }

    componentDidMount() {
        this.props.onActivate();
    }

    componentDidUpdate(prevProps, prevState) {
        const { provider } = this.props;
        if (provider !== null && !_.isEqual(prevProps.provider, provider)) {
            this.setState({ provider });
        }
    }

    toggleRowMenu = currentTarget => {
        this.setState((prevState) => {
            return { anchorEl: prevState.anchorEl === currentTarget ? null : currentTarget }
        })
    }

    closeToggleRowMenu = () => {
        this.setState({ anchorEl: null });
    }

    toggleCreateModal = e => {
        const { showModal } = this.state;
        this.setState({ showModal: !showModal, name: '', isUpdate: false });
    }

    toggleEditModal = e => {
        const { name, showModal } = this.state;
        this.setState({ showModal: !showModal, name: name, isUpdate: true });
    }

    handleInputChange = name => this.setState({ name })

    selectElement = (user, index) => {
        this.setState({ name: user.name, selectedIndex: index });
    }

    createOrUpdateExternalField = e => {
        const { provider, onProviderUpdated } = this.props;
        const { name, isUpdate, selectedIndex } = this.state;
        if (!isUpdate) {
            onProviderUpdated(Object.assign({}, provider, { externalFields: [...provider.externalFields, name] }), 'add_external_field');
        } else {
            let aux = Object.assign([], provider.externalFields);
            aux.splice(selectedIndex, 1, name);            
            onProviderUpdated(Object.assign({}, provider, { externalFields: aux }), 'update_external_field');
        }
        this.toggleCreateModal(e);
        this.setState({ name: '', anchorEl: null });
    }

    deleteExternalField = () => {
        const { provider, onProviderUpdated } = this.props;
        const { name } = this.state;
        onProviderUpdated(Object.assign({}, provider, { externalFields: provider.externalFields.filter(x => x !== name) }), 'delete_external_field');
        this.setState({ name: '', anchorEl: null });
    }

    render() {
        const { provider, loading } = this.props;
        const { showModal, name, anchorEl } = this.state;

        return (<AppContent>
                    {
                        loading && <LinearProgress variant="query" />
                    }
                    <DataTableToolbar title="External Fields" numSelected={0} >
                        <Tooltip title="Add New">
                            <IconButton onClick={this.toggleCreateModal} color="secondary"><AddCircleIcon /></IconButton>
                        </Tooltip>
                    </DataTableToolbar>
                    {
                        provider && provider.externalFields &&
                        <DataTable columns={[{ label: 'Field', field: 'name' }]} anchorEl={anchorEl} rows={provider.externalFields.map(x => ({ name: x }))}
                            toggleRowMenu={this.toggleRowMenu} onElementSelect={this.selectElement} onCloseToggleRowMenu={this.closeToggleRowMenu}>
                            <MenuItem onClick={this.toggleEditModal}>
                                <ListItemIcon><EditIcon /></ListItemIcon>
                                <ListItemText inset primary="Settings" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={this.deleteExternalField}>
                                <ListItemIcon><DeleteForeverIcon /></ListItemIcon>
                                <ListItemText inset primary="Delete" />
                            </MenuItem>
                        </DataTable>
                    }
                    <CreateModal title="Create/Edit External Field" open={showModal} closeHandler={this.toggleCreateModal} saveHandler={this.createOrUpdateExternalField}>
                        <Grid container item spacing={24}>
                            <Grid item xs>
                                <TextField autoFocus value={name} onChange={e => this.handleInputChange(e.target.value)} id="name" name="name" label="Field" type="text" fullWidth />
                            </Grid>
                        </Grid>
                    </CreateModal>
                </AppContent>)
    }
}

ExternalFieldList.propTypes = {
    provider: PropTypes.object.isRequired,
};


export default ExternalFieldList;


// WEBPACK FOOTER //
// ./src/Components/Presentation/Providers/ExternalFields/ExternalFieldList.js